import { planTypes } from '@/common/constants';
import { isFromZeConsumption } from '@/plans/EVENT_SAAS/helper/utils';

export default {
  key: planTypes[planTypes.EVENT_SAAS_CORE],
  data() {
    return {
      logo: require('@/assets/plans/eventsaascore.svg'),
      title: `${this.$t('billing.planform.title.eventsaascore')}${isFromZeConsumption() ? ' ' + this.$t('billing.events.ppa.title') : ''}`,
      subtitle: '',
      capacityKey: 'capacity',
      planType: planTypes.EVENT_SAAS_CORE,
      description: this.$t('billing.events.eventSaasCore.addon_desc'),
      totalLimitDesc: "",
      configDescription: this.$t('billing.events.eventSaasCore.desc'),
    };
  },
};
